import 'core-js/features/array/to-reversed';
import 'core-js/features/array/to-sorted';
import 'core-js/features/array/to-spliced';
import 'core-js/features/array/with';
import 'core-js/features/string/replace-all';
